module.exports = __webpack_public_path__ + "static/media/3-devices-black.537ccdeb.png";